import { useCallback } from 'react';
import {
  getInitialState,
} from '@/creditflowresearch/application/Bonds/BondsFiltersContext/helpers';
import { useRouter } from '@framework/router';
import { useBondsAssetClassesContext } from '../BondsAssetClassesContext';
import { useCheckboxerContext } from '@framework/ui/Organisms/Filters/Checkboxer/CheckboxerContext';
import { useDateFilterProcessing } from '@/creditflowresearch/application/hooks/useDateFilterProcessing';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';

type TFiltersState = ReturnType<typeof getInitialState>;

export const useBondsFiltersInitialisation = ({
  getFiltersPayload,
  setFiltersPayload,
  initBondsFilters,
  initial,
}) => {
  const { currentAssetClass } = useBondsAssetClassesContext();
  const { query: queryParams } = useRouter();
  const { checkboxes } = useCheckboxerContext();
  const applyDateFilters = useDateFilterProcessing<TFiltersState>();
  const { filtersUpdate } = useFiltersContext();
  type TFiltersPayload = ReturnType<typeof getFiltersPayload>;

  return useCallback(async (payload = null) => {
    let isHashFiltersPayload = false;
    let filtersState: TFiltersState = getInitialState();
    let initialFiltersPayload: TFiltersPayload = getFiltersPayload(filtersState, checkboxes);
    let filtersPayload: TFiltersPayload = initialFiltersPayload;

    if (currentAssetClass?.id) {
      initialFiltersPayload.includedAssetClassId = currentAssetClass.id;
    }

    if ('hash' in queryParams) {
      isHashFiltersPayload = true;
      filtersPayload = initial;
    }

    if (payload) {
      filtersPayload = payload;
    }

    applyDateFilters(filtersState, filtersPayload);

    setFiltersPayload(filtersPayload);

    await initBondsFilters(
      filtersPayload,
      isHashFiltersPayload ? undefined : filtersState,
      isHashFiltersPayload,
      filtersUpdate,
    );
  }, [queryParams, currentAssetClass, checkboxes, initial]);
};
